import { Button } from "@blueprintjs/core";
import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { PMDNDTypes } from "./constants";
import './PMWindowedApp.css';

class PMWindow extends Component {


	render() {
		const { minimized, window } = this.props;
		const { xLeft, yTop, size_w, zIndex, buttons } = window;

		const winStyle = {
			top: yTop,
			left: xLeft,
			width: size_w,
			zIndex: zIndex
		}

		return (
			<div className="PMWindow" style={winStyle}>
				{!minimized ? this.header() : this.headerClosed()}
				{!minimized ? this.body() : this.bodyClosed()}
				{!minimized && buttons ? this.footer() : this.footerClosed()}
			</div>
		)
	}

	header = () => {
		const { connectDragSource, data, funcMinimize, funcMoveZ, funcClose, color } = this.props;
		const headStyle = {
			backgroundImage: 'linear-gradient(to right, ' + color + ', white)',
		}

		return connectDragSource(
			<div className="PMWindowHeader" style={headStyle} onClick={funcMoveZ} onDoubleClick={funcMinimize}>
				<div className="PMWindowHeaderLeft">
					<Button icon="minimize" onClick={funcMinimize} />
				</div>

				{data.display /* DEBUG - (x:{xLeft},y:{yTop}) - z: {zIndex}*/}

				<div className="PMWindowHeaderRight">
					<Button icon="cross" onClick={funcClose} />
				</div>
			</div>
		)
	}

	headerClosed = () => {
		const { connectDragSource, data, funcMinimize, funcClose, color } = this.props;
		const headStyle = {
			backgroundImage: 'linear-gradient(to right, ' + color + ', white)',
			textShadow: '1px 1px #000000'
		}

		return connectDragSource(
			<div className="PMWindowHeader" style={headStyle} onDoubleClick={funcMinimize}>
				<div className="PMWindowHeaderLeft">
					<Button icon="maximize" onClick={funcMinimize} />
				</div>

				{data.display}

				<div className="PMWindowHeaderRight">
					<Button icon="cross" onClick={funcClose} />
				</div>
			</div>
		)
	}

	body() {
		const { funcMoveZ } = this.props;
		return (
			<div className={"PMWindowContent pm-uncollapse"} onDoubleClick={funcMoveZ} onClick={funcMoveZ} >
				{this.props.children}
			</div>
		)
	}

	bodyClosed() {
		const { funcMinimize } = this.props;
		return (
			<div className={"PMClickableArea pm-collapse"} onDoubleClick={funcMinimize} > <br /> </div> /* -- NOTE IMPORTANT line break so the element has an area--*/
		)
	}

	footer() {
		const { funcAction, funcMinimize, window } = this.props;
		const { actions, buttons } = window;
		return (
			<div className="PMWindowFooter" onDoubleClick={funcMinimize}>
				{buttons.map(
					(bt, index) =>
						<span key={index + bt}>
							<Button onClick={() => funcAction(actions[index])}> {bt} </Button>
						</span>
				)}
			</div>
		)
	}

	footerClosed() {
		const { funcMinimize } = this.props;
		return (
			<div className="PMWindowFooterClosed" onDoubleClick={funcMinimize} ></div>
		)
	}
}

const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("dragging");
	},
	endDrag: function (props, monitor, component) {
		//console.log("endDrag")
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

PMWindow = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(PMWindow);
export default PMWindow;


// WEBPACK FOOTER //
// ./src/components/projectmanager/PMWindow.js